// @flow
import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { applyMiddleware, compose, createStore } from 'redux'
import thunkMiddleware from 'redux-thunk'
// TODO: figure out why this works but not roboto and fontawesome
import 'material-design-icons/iconfont/material-icons.css'
// import 'font-awesome/css/font-awesome.css'
// import 'mapskin/css/mapskin.css'
// import 'typeface-roboto/index.css'
import { withStyles } from '@material-ui/core/styles'
import App from './containers/app'
import { emit } from './modules/websockets/client/actions/'
import reducer from './reducers'
import styles from './styles'
import '../css/global.css'

// Global css
import '../../node_modules/rc-slider/assets/index.css'

// Support AJAX calls via thunk, websockets with emit
const middleware = [thunkMiddleware.withExtraArgument({ emit })]
const store = createStore(reducer, applyMiddleware(...middleware))

const AppStyled = withStyles(styles)(App)
const root = document.getElementById('root')
if (root) {
    render(
        <Provider store={store}>
            <BrowserRouter>
                <AppStyled store={store} />
            </BrowserRouter>
        </Provider>,
        root,
    )
}
